import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieValueRelation implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushie: string,
    private fValue: string
  ) {
    [fId, fPlushie, fValue].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get plushie() {
    return this.fPlushie;
  }

  get value() {
    return this.fValue;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get updatedAt() {
    return this.fUpdatedAt;
  }
}
